import { Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Users } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { useCircleNames } from "@/lib/circle-experts";

/** Плашка с названием сообщества. circleId — из строки события; без него — по публичной функции. */
export function AegisBadge({ circleId, eventId, className = "" }: { circleId?: string | null; eventId?: string; className?: string }) {
  const { data: names } = useCircleNames([circleId]);
  const { data: pub } = useQuery({
    queryKey: ["public-event-circle", eventId],
    enabled: circleId === undefined && !!eventId,
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const { data } = await supabase.rpc("public_event_circle", { event_id: eventId! });
      const r = ((data ?? []) as { circle_id: string; circle_name: string }[])[0];
      return r ?? null;
    },
  });
  const id = circleId ?? pub?.circle_id;
  const name = circleId ? names?.get(circleId) : pub?.circle_name;
  if (!id || !name) return null;
  return (
    <Link
      to="/circles/$circleId"
      params={{ circleId: id }}
      onClick={(e) => e.stopPropagation()}
      className={`inline-flex min-w-0 max-w-full items-center gap-1 rounded-full border border-td-teal px-2 py-0.5 text-[11px] font-semibold text-td-teal ${className}`}
    >
      <Users className="h-3 w-3 shrink-0" />
      <span className="truncate">{name}</span>
    </Link>
  );
}
